import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconAskAI(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M9.25 8C8.56 8 8 8.56 8 9.25v5.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-5.5C16 8.56 15.44 8 14.75 8h-5.5Zm.75 6v-4h4v4h-4Z"
        clipRule="evenodd"
      />
      <path
        fill="url(#b)"
        fillRule="evenodd"
        d="M10 2a1 1 0 0 1 1 1v1h2V3a1 1 0 1 1 2 0v1h3a2 2 0 0 1 2 2v3h1a1 1 0 1 1 0 2h-1v2h1a1 1 0 1 1 0 2h-1v3a2 2 0 0 1-2 2h-3v1a1 1 0 1 1-2 0v-1h-2v1a1 1 0 1 1-2 0v-1H6a2 2 0 0 1-2-2v-3H3a1 1 0 1 1 0-2h1v-2H3a1 1 0 1 1 0-2h1V6a2 2 0 0 1 2-2h3V3a1 1 0 0 1 1-1Zm8 4H6v12h12V6Z"
        clipRule="evenodd"
      />
      <defs>
        <linearGradient id="a" x1="2" x2="21.5" y1="2" y2="21.5" gradientUnits="userSpaceOnUse">
          <stop offset=".175" stopColor="#63D6FA" />
          <stop offset="1" stopColor="#E039CE" />
        </linearGradient>
        <linearGradient id="b" x1="2" x2="21.5" y1="2" y2="21.5" gradientUnits="userSpaceOnUse">
          <stop offset=".175" stopColor="#63D6FA" />
          <stop offset="1" stopColor="#E039CE" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
